(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    // ページ全体でクリックを監視し、クリックされたものがターゲットなら実行
document.addEventListener('click', (event) => {
  const match = window.location.pathname.match(/\/products\/(\d+)/);
  const product_id = match ? match[1] : null

  const trackingUrl = `https://cookpad.com/jp/shopify_ec_ad_log?page=cart&v=${Date.now()}&product_id=${product_id}`;
  const targetButton = event.target.closest('.qsc2-stickybar__action-btn, [data-main-purchase-button]')

  if (targetButton) {
    fetch(trackingUrl, { method: 'GET', credentials: 'include', keepalive: true });
    console.log('Action button clicked (dynamic)');
  }
});
  } catch(e) { console.error(e); }
})();

})();
